export default "__VITE_ASSET__11219a5c__"